import React from "react";
import { Info } from "lucide-react";
import ResultBox from "../shared/ResultBox";
import FinancialStampResult from "./FinancialStampResult";
import GenericStampResult from "./GenericStampResult";
import { fmt } from "../utils/format";

export default function ResultsPanel({ result, toDisplay, unitLabel }) {
  if (!result) return null;

  return (
    <div className="rounded-2xl p-6 space-y-5 bg-neutral-800">
      <div className="flex items-start gap-2 text-xs text-neutral-400">
        <Info size={14} className="mt-0.5 shrink-0" />
        <span>{result.note}</span>
      </div>

      {result.isRange && (
        <div className="text-xs text-neutral-400">
          محدوده قانونی: {fmt(toDisplay(result.min))} تا{" "}
          {fmt(toDisplay(result.max))} {unitLabel}
        </div>
      )}

      {result.hasStages ? (
        <div className="grid sm:grid-cols-2 gap-4">
          <ResultBox
            label="حق‌الوکاله مرحله بدوی (۶۰٪)"
            value={`${fmt(toDisplay(result.stageFirst))} ${unitLabel}`}
          />
          <ResultBox
            label="حق‌الوکاله مرحله تجدیدنظر (۴۰٪)"
            value={`${fmt(toDisplay(result.stageAppeal))} ${unitLabel}`}
          />
        </div>
      ) : (
        <ResultBox
          label="جمع حق‌الوکاله محاسبه‌شده"
          value={`${fmt(toDisplay(result.total))} ${unitLabel}`}
          wide
        />
      )}

      {result.isFinancialStamp ? (
        <FinancialStampResult
          result={result}
          toDisplay={toDisplay}
          unitLabel={unitLabel}
        />
      ) : (
        <GenericStampResult
          result={result}
          toDisplay={toDisplay}
          unitLabel={unitLabel}
        />
      )}

      <p className="text-[11px] leading-5 text-neutral-400">
        ارقام صرفاً جنبه راهنما دارد؛ برای محاسبه نهایی و الزام‌آور، با وکیل یا
        کارشناس مالیاتی مشورت کنید.
      </p>
    </div>
  );
}
